<template>
  <div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/home_banner1.png" alt="#">
          <h2>中国移动（呼和浩特）数据中心</h2>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="section_w content">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            服务内容
          </p>
          <aside>
            content
          </aside>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../assets/content_pic01.jpg" alt="">
            <div>
              <router-link to="/idc">
                <p class="text_ellipsis">
                  IDC
                </p>
                <div class="text">
                  分布在全国大多数重要城市的分布式节点...
                </div>

                <span>
                更多 >
              </span>
              </router-link>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../assets/content_pic02.jpg" alt="">
            <div>
              <router-link to="/internet">
                <p class="text_ellipsis">
                  物联网
                </p>
                <div class="text">
                  悦享互联为制造业、物流运输、医疗设备等行业...
                </div>
                <span>更多 ></span>
              </router-link>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../assets/content_pic03.jpg" alt="">
            <div>
              <router-link to="/cdn">
                <p class="text_ellipsis">
                  智能融合CDN
                </p>
                <div class="text">
                  悦享互联提供全网优质资源调度 打造极致服务体验...
                </div>
                <span href="#">更多 ></span>
              </router-link>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../assets/content_pic04.jpg" alt="">
            <div>
              <router-link to="/ict">
                <p class="text_ellipsis">
                  ICT系统集成服务
                </p>
                <div class="text">
                  软硬件系统集成、设备供货、物联网方案等...
                </div>
                <span href="#">更多 ></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w Program" style="padding-bottom: 0px">
      <div class="container" style="position: relative; z-index: 10">
        <div class="section_title right">
          <p>
            解决方案
          </p>
          <aside>
            Solution
          </aside>
        </div>
      </div>
      <div class="program_content program_content_big">
        <div class="container">
          <div class="row">
            <div class="col-sm-3 program_card">
              <p>多种线路</p>
              <span>
              BGP、SDN、MSTP、DDN专线，网络更快，更稳定
            </span>
              <div class="text-center">
                <img src="../assets/program_icon01.png" alt="">
              </div>
            </div>
            <div class="col-sm-3 program_card" style="padding-top: 170px">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon02.png" alt="">
              </div>
              <p>覆盖广泛</p>
              <span>
              北京、上海、广州、武汉等核心节点，分布在全国大多数重要城市的2、3级优势节点
            </span>
            </div>
            <div class="col-sm-3 program_card">
              <p>服务保障</p>
              <span>
              先进的标准化数据中心，整体一站式托管服务
            </span>
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon03.png" alt="">
              </div>
            </div>
            <div class="col-sm-3 program_card" style="padding-top: 100px">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon04.png" alt="">
              </div>
              <p>专业团队</p>
              <span>
              专业的运维团队、以百度自动化运维为核心的保障技术
            </span>
            </div>
          </div>
        </div>
      </div>
      <div class="program_content program_content_xs">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon01.png" alt="">
              </div>
              <p>多种线路</p>
              <span>
              BGP、SDN、MSTP、DDN专线，网络更快，更稳定
            </span>

            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon02.png" alt="">
              </div>
              <p>覆盖广泛</p>
              <span>
              北京、上海、广州、武汉等核心节点，分布在全国大多数重要城市的2、3级优势节点
            </span>
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon03.png" alt="">
              </div>
              <p>服务保障</p>
              <span>
              先进的标准化数据中心，整体一站式托管服务
            </span>

            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 program_card">
              <div class="text-center" style="margin-bottom: 20px">
                <img src="../assets/program_icon04.png" alt="">
              </div>
              <p>专业团队</p>
              <span>
              专业的运维团队、以百度自动化运维为核心的保障技术
            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w introduction">
      <div class="container" style="position: relative;z-index: 33">
        <div class="section_title left">
          <p>
            公司简介
          </p>
          <aside>
            Introduction
          </aside>
        </div>
        <div class="parper">
          <div class="row clearfix" style="position: relative">
            <div class="col-sm-6 introduction_text">
              <div class="i_title">
                <h4>
                  北京悦享互联技术有限公司
                </h4>
                <span>
                    Beijing Yoxnet Internet Technology Co., Ltd.
                  </span>
              </div>
              <p>
                北京悦享互联技术有限公司秉承为万物互联、应用智能做出技术贡献为使命，为客户的数据安全连接和应用智能提供技术保障，是一家专注于企业互联网数据接入和业务咨询的技术服务公司。
              </p>
            </div>
            <div class="col-sm-6 img_w">
              <img src="../assets/introduction_pic01.png" style="height: 100%" alt="">
            </div>
            <div class="col-sm-6 img_xs_view" style="display: none">
              <img src="../assets/introduction_pic01.png" style="height: 100%" alt="">
            </div>
          </div>
          <div class="clearfix introduction_link">
            <div class="col-sm-4">
              <router-link to="introduction" class="a_block">
                <h5>
                  公司简介
                </h5>
                <p class="text_ellipsis">
                  公司核心业务包括：为企事业提供基于移动互联网的IT系统规划及建设，企业分布式IDC数据接入和选点规划，软硬件设计、建设等服务。
                </p>
                <span>更多 > </span>
              </router-link>
            </div>
            <div class="col-sm-4">
              <router-link to="/hope" class="a_block">
                <h5>
                  公司愿景
                </h5>
                <p class="text_ellipsis">
                  以秉承为万物互联、应用智能贡献技术力量为使命。 为客户的数据安全连接和应用智能提供技术保障。
                </p>
                <span>更多 > </span>
              </router-link>
            </div>
            <div class="col-sm-4">
              <router-link to="honor" class="a_block">
                <h5>
                  荣誉资质
                </h5>
                <p class="text_ellipsis">
                  北京悦享互联技术有限公司荣获...
                </p>
                <span>更多 > </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import Footer from '../components/Footer'
  export default {
    name: 'Dashboard',
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
      });
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-container {
    width: 100%;
  }

  img {
    width: 100%;
  }

  .swiper-slide {
    position: relative;
    text-align: center;
    font-size: 1.8rem;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide h2{
    position: absolute;
    bottom: 10%;
    left: 50%;
    width: 73%;
    margin: 0;
    line-height: 1.5;
    transform: translateX(-50%);
    font-size: 50px;
    color: white;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .index_content_card {
    margin-bottom: 30px;
  }

  .index_content_card p {
    color: #ff9900;
    font-size: 2.4rem;
    margin-bottom: 5px;
  }

  .index_content_card > div {
    padding: 15px;
    border-bottom: 3px solid #fe9901;
    background-color: #fff;
  }

  .index_content_card span {
    margin-top: 8px;
    color: #2c3e50;
    display: block;
  }

  .index_content_card .text {
    color: #2c3e50;
  }

  .index_content_card .text {
    height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size:18px;
  }

  .content {
    background: url("../assets/content_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
  }
  .content:after {
    content: "";
    display: block;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    background: url("../assets/content_c_font.png") no-repeat 105% 20%;
    background-size: 32%;
    z-index: 1;
  }
  .program_content {
    position: relative;
  }
  .program_content:after {
    content: "";
    display: block;
    position: absolute;
    left: 0px;
    top: -160px;
    height: 100%;
    width: 100%;
    background: url("../assets/program_p_font.png") no-repeat 4% 18%;
    background-size: 32%;
    z-index: 0;
  }

  .index_content_card:hover > div {
    background-color: #fe9901;
  }

  .index_content_card:hover p {
    color: #fff
  }

  .index_content_card:hover span {
    color: #fff
  }

  .index_content_card:hover .text {
    color: #fff
  }

  .program_content {
    background: url("../assets/program_bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    padding: 40px 0px 0px;
  }

  .program_card p {
    text-align: center;
    color: #8c4c00;
    font-size: 2.8rem;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .program_card span {
    color: #8c4c00;
    font-size: 2rem;
    margin-bottom: 20px;
    display: block;

  }

  .program_card img {
    width: 100px;
  }

  .program_content_xs {
    display: none;
  }

  .program_card {
    margin-bottom: 30px;
  }

  .parper {
    box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);
  }
  .introduction{
    background: url("../assets/introduction_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    z-index: 10;
  }
  .introduction:after {
    content: "";
    display: block;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    background: url("../assets/introduction_i_font.png") no-repeat 105% 16%;
    background-size: 22%;
    z-index: 1;
  }
  .introduction_text {
    color: #333333;
    padding: 60px 5px 40px 35px;

  }

  .introduction_text h4 {
    color: #333;
  }

  .introduction_text .i_title {
    border-left: 3px solid #fe9901;
    padding-left: 2rem;
    margin-bottom: 30px;
  }

  .introduction_text .i_title h4 {
    font-size: 3.2rem;

  }

  .introduction_text p{

    font-size:18px;
    line-height:32px;

  }

  .img_w {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 50%;
    height: 100%;
  }

  .introduction_link > div {
    padding: 0px;
  }

  .introduction_link h5 {
    font-size: 3.2rem;
    position: relative;
    color: #333;
    margin-bottom: 1rem;
  }

  .introduction_link p {
    color: #333;
    margin-bottom: 1rem;
    font-size:18px;
  }

  .introduction_link span {
    color: #333;
  }

  .introduction_link h5:after {
    content: "";
    display: block;
    width: 40px;
    height: 3px;
    position: absolute;
    top: -20px;
    left: 1px;
    background-color: #fe9902;
  }

  .introduction_link a {
    padding: 4rem 1rem 2rem;
    background: #f5f5f5;
  }

  .introduction_link a:hover {
    background: #fe9902;
  }

  .introduction_link a:hover h5, .introduction_link a:hover p, .introduction_link a:hover span {
    color: #fff;
  }

  .introduction_link a:hover h5:after {
    background-color: #fff;
  }



  @media (max-width: 991px) {
    .program_content_big {
      display: none;
    }

    .program_content_xs {
      display: block;
    }

    .swiper-slide h2 {
      font-size: 4rem;
    }

  }

  @media (min-width: 992px) {

    .introduction_text {
      min-height: 320px;
    }
  }

  @media (max-width: 768px) {
    
    .swiper-slide h2 {
      font-size: 2rem;
    }

    .img_xs_view {
      display: block !important;
    }

    .img_w {
      display: none;
    }

    .introduction_text {
      color: #333333;
      padding: 60px 30px 40px 30px;
    }
    .content:after {
      display: none;
    }
    .Program:after {
      display: none;
    }

  }
</style>
